// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3zCYC","isLive":"footer-module--is-live--EwWVx","liveDot":"footer-module--live-dot--2W1Xr","unix":"footer-module--unix--376wm"};